import React, { memo, useEffect, useState } from "react";
import { getUserPhoto } from "../../services/Fonction__Services";
import { findOne } from "../../services/User__Service";

const CardUser = ({ userId = 0, initialUser = null }) => {
  const [user, setUser] = useState(null);
  const [image, setImage] = useState(null);

  useEffect(() => {
    if (userId !== 0) {
      fetchOneUser(userId);
    }
  }, [userId]);

  useEffect(() => {
    if (initialUser) {
      setUser({ ...initialUser });
      fecthFile(initialUser.photo);
    }
  }, []);

  const fetchOneUser = async (idParams) => {
    findOne(idParams)
      .then((response) => {
        setUser(response.data);
        fecthFile(response.data.photo);
      })
      .catch(() => {
        setUser(null);
      });
  };

  const fecthFile = async (photo) => {
    getUserPhoto(photo)
      .then((response) => {
        setImage(response.data);
      })
      .catch(() => {
        setImage(null);
      });
  };

  const getProfile = (profil) => {
    let result = "";
    switch (parseInt(profil)) {
      case 1:
        result = "Gestionnaire";
        break;
      case 2:
        result = "Salarié";
        break;
      case 3:
        result = "Admin";
        break;
      default:
        break;
    }
    return result;
  };

  return (
    user && (
      <div className="card-salarie">
        <div>
          {image && (
            <img
              src={URL.createObjectURL(image)}
              alt="image"
              className="image"
            />
          )}
          <div className="primary-info">
            <div>
              <p className="nom">
                {user.fullname.length <= 20
                  ? user.fullname
                  : user.fullname.substring(0, 19) + "..."}
              </p>
              <p className="sigle">{getProfile(user.compte.profil)}</p>,
            </div>
            <p className={`statut ${user.statut == 0 && "inactif"}`}>
              {user.statut == 0 ? "inactif" : "Actif"}
            </p>
          </div>
        </div>
        <div className="secondary-info">
          <p>
            <strong>Nom d'utilisateur : </strong> {user.compte.login}
          </p>
          <p>
            <strong>Email : </strong> {user.email1}
          </p>
          <p>
            <strong>Tél : </strong> {user.tel1}
          </p>
        </div>
      </div>
    )
  );
};

export default memo(CardUser);
